import { Link } from 'react-router-dom'

type BasicNavItemProps = {
  isAuthenticated: boolean
  login: () => void
  logout: () => void
}

const BasicNavItem: React.ElementType<BasicNavItemProps> = ({
  isAuthenticated,
  login,
  logout,
}) => {
  return isAuthenticated ? (
    <Link to="#" onClick={logout}>
      Sign out
    </Link>
  ) : (
    <Link onClick={login} to="/">
      Sign in
    </Link>
  )
}

export default BasicNavItem
